/* eslint-disable no-underscore-dangle */

import moment from 'moment';
import deepMap from '../../../object/deepMap';

const mapper = value => {
    let arr;

    if (value?._type) {
        switch (value._type) {
            case 'number':
                return Number(value._value);
            case 'boolean':
                return value._value === 'true';
            case 'date':
                return new Date(value._value);
            case 'moment':
                return moment(value._value);
            case 'set':
                return new Set(value._value?.map(mapper));
            case 'array':
                if (!value._value) {
                    arr = [];
                } else if (!Array.isArray(value._value)) {
                    arr = Object.values(value._value);
                } else {
                    arr = value._value;
                }

                return arr.map(mapper);
            case 'null':
                return null;
            default:
                return value._value;
        }
    }

    return value;
};

const deserializeFromQueryString = object => deepMap(object, mapper, obj => obj?._type);

export default deserializeFromQueryString;
